// Signing in and around it: the sign-in screen, the invitation, access denied.
// The first two show BEFORE we know whether the organisation has English:
// they follow the browser language.
export default {
  langue: 'Language',
  passerEnClair: 'Switch to light mode',
  passerEnSombre: 'Switch to dark mode',
  seConnecter: 'Sign in',
  login: {
    adresse: 'Email',
    exempleAdresse: "you{'@'}example.com",
    motDePasse: 'Password',
    enCours: 'Signing in…',
    navigationEchouee: 'Signed in, but navigation failed: {erreur}. Please reload the page.',
    note: 'Access is granted by an administrator and takes effect when you sign in: a permission granted a moment ago requires you to sign in again.',
  },
  invitation: {
    chargement: 'Loading…',
    indisponible: 'Invitation unavailable',
    titre: 'Invitation',
    rejoindre: 'Join {organisation}',
    choisirMotDePasse: 'Choose a password',
    encore: 'Still needed: {manques}',
    confirmer: 'Confirm password',
    unInstant: 'One moment…',
    sessionOuverte: 'Signed in as {email}. Please sign in with the invited address.',
    votreMotDePasse: 'Your Orion password',
    seConnecterEtRejoindre: 'Sign in and join {organisation}',
    doitContenir: 'The password must contain {manques}.',
    differents: 'The two passwords do not match.',
    manques: {
      longueur: '12 characters',
      minuscule: 'a lowercase letter',
      majuscule: 'an uppercase letter',
      chiffre: 'a digit',
      symbole: 'a symbol',
    },
  },
  acces: {
    titre: 'Access denied',
    demande: 'This screen requires the {module} permission, which this account does not have.',
    refuse: 'This account does not have permission to open this screen.',
    ceCompte: 'This account',
    modulesAccordes: 'Modules granted',
    aucun: 'None. Your organisation’s administrator grants them from the Team page.',
    seReconnecter: 'Sign in again',
    retour: 'Back',
  },
}
